import i18n from '@/i18n';
import { createToaster } from '@meforma/vue-toaster';

const { t } = i18n.global;
const toaster = createToaster({ position: 'top-right' });

export function copyToClipboard(text) {
  return navigator.clipboard
    .writeText(text)
    .then(() => toaster.success(t('general.codigoCopiado')))
    .catch(() => toaster.error(t('general.errorCopiarCodigo')));
}

export function share({ title = document.title, text, url } = {}) {
  if (!navigator.share) return Promise.resolve();

  return navigator
    .share({
      title,
      text: text,
      url: url ?? window.location.href,
    })
    .catch(() => {});
}
